export const genderTranslation = {
    male: 'Mand',
    female: 'Kvinde',
    other: 'Andet',
    unknown: 'Ikke oplyst',
};
